/**------------------------------------------------------
 * RxJs Event
 * ----------
 * ...
 */
export class RxJsEvent {
	// ...
}
